import { Media, Result } from '@/classes'

export const mediaUploadRequestAPI = async (params: {
  directory?: string,
  isPalette?: boolean,
  size?: 'default' | 'events' | 'post' | 'profile-picture' | 'story',
	mimetype: string
  type?: 'image' | 'gif' | 'audio',
  extract?: { width: number, height: number, x: number, y: number }
}, controller?: AbortController) => {
	const response: Result<{
		url: string
		token: string
	}> = await fetchAPI('media/upload/request', params, { method: 'POST', controller })

	if (!response.ok) return response

	return {
		ok: true,
		data: response.data
	}
}

export const mediaUploadCompleteAPI = async (token: string) => {
	const response: Result<{ success: boolean, media: Media }> = await fetchAPI('media/upload/complete', { token }, { method: 'POST' })

	if (!response.ok) return response

	return response
}

export const mediaUploadAPI = async (params: {
	file: File
	url: string
}) => {
	await $fetch(params.url, {
		body: params.file,
		method: 'PUT',
		headers: {
			'Content-Type': params.file.type
		}
	})

	return {
		ok: true,
		data: { success: true }
	}
}